import React from 'react'
import { Box, Stack, Typography } from '@mui/material'

interface LegendProps {
  label: string
  color: string
  borderRadius?: string
}

const Legend: React.FC<LegendProps> = ({ label, color, borderRadius = '4px' }) => {
  return (
    <Stack direction={'row'} gap={1} alignItems={'baseline'}>
      <Box sx={{ 
        width: '10px', 
        height: '10px', 
        backgroundColor: color,
        borderRadius: borderRadius 
      }} />
      <Typography variant={'caption'}>{label}</Typography>
    </Stack>
  )
}

export default Legend